import React, { useEffect, useState } from 'react';
import api from '../../../../config/configApi';
import { Alert, Breadcrumbs, Chip, CircularProgress, emphasize, Paper, styled } from '@mui/material';
import { MdHome } from 'react-icons/md';
import { DataGrid } from '@mui/x-data-grid';
import { localeText } from '../../../../utils/webConstants';
import moment from 'moment';
import { useAuth } from '../../../../context/AuthContext';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    return {
        backgroundColor: theme.palette.grey[100],
        height: theme.spacing(3),
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(theme.palette.grey[100], 0.06),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.06),
            }),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(theme.palette.grey[100], 0.12),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.12),
            }),
        },
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    };
});

const paginationModel = { page: 0, pageSize: 5 };

function DashboardLogsAcessos() {
    const { user } = useAuth();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLogs = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/logs/acessos');
                setLogs(response.data);
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar logs de acessos.';
                setError(errMessage);
                setLogs([]);
            } finally {
                setLoading(false);
            }
        }

        fetchLogs();
    }, [])

    const columns = [
        {
            field: 'data', headerName: 'DATA', width: 200, type: 'datetime',
            renderCell: (params) => moment.utc(params.row.data).format('DD/MM/YYYY HH:mm:ss')
        },
        { field: 'email', headerName: 'EMAIL', width: 400 },
        { field: 'ip', headerName: 'IP', width: 150 },
    ]

    return (
        <>
            <div className='card shadow border-0 w-100 flex-row p-4 res-col'>
                <h5 className='mb-0'>Logs acessos</h5>
                <Breadcrumbs
                    aria-label='breadcrumb'
                    className='ms-auto breadcrumbs_'
                >
                    <StyledBreadcrumb label='Dashboard' icon={<MdHome fontSize='small' />} />
                    <StyledBreadcrumb label='Logs' />
                    <StyledBreadcrumb label='Acessos' />
                </Breadcrumbs>
            </div>
            <div className='card p-3 mt-4'>
                {loading && !error && (
                    <div className='d-flex w-100 align-items-center justify-content-center'>
                        <CircularProgress />
                    </div>
                )}
                {!loading && error && (
                    <Alert severity='error'>{error}</Alert>
                )}
                {!loading && !error && !user.acesso && (
                    <Alert severity='warning'>Seu usuário não possui permissão para visualizar!</Alert>
                )}
                {!loading && !error && logs.length === 0 && user.acesso && (
                    <p>Nenhum log encontrado</p>
                )}
                {!loading && !error && logs.length > 0 && user.acesso && (
                    <Paper sx={{ height: 400, width: '100%' }}>
                        <DataGrid
                            rows={logs}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            rowSelection={false}
                            localeText={localeText}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                }
                            }}
                        />
                    </Paper>
                )}
            </div>
        </>
    )
}

export default DashboardLogsAcessos;